import { useTranslation } from "react-i18next";
import { Box, Divider, List, ListItem, ListItemText, Stack } from "@mui/material";

import { SubscriptionVariants } from "../../../types/rtk/subscription/subscription";
import CarouselCard from "../../atoms/CarouselCard/CarouselCard";
import Chip from "../../atoms/Chip/Chip";
import Text from "../../atoms/Text/Text";
import { getCarouselSubscriptionPaymentDescription, getCarouselSubscriptionTitle } from "../../../helpers/getSubscriptionTitle";
import { formatPrice } from "../../../helpers/currencyHelper";
import StarIcon from '@mui/icons-material/Star';

interface Props {
  data: SubscriptionVariants;
  isActive: boolean;
}

const SubscriptionCarouselCard = ({ data, isActive }: Props) => {
  const { t } = useTranslation();

  return (
    <CarouselCard className="SubscriptionCarouselCard" isActive={isActive}>
      {data.period === 24 && (
        <Chip
          className="popularChip"
          text={t("subscriptioncarousel:CARDSBLOCK_BADGE_POPULAR")}
          icon={<StarIcon />}
        />
      )}
      {
        data.period !== 1
        ? <Chip isActive text={t('subscriptioncarousel:CARDSBLOCK_BADGE_GUARANTEE')} />
        : <span style={{ height: 20 }} />
      }
      <Stack sx={{ alignItems: 'start' }}>
        <Text className="bold">{getCarouselSubscriptionTitle(data.period)}</Text>
        <Box className="subscriptionPrice">
          <Box className="prices">
            <Text className={data.period !== 1 ? "color bold" : "bold"}>
              {`${formatPrice(data.price.amount / data.period, data.price.currency)}`}
            </Text>
            <Text className="bold">
              {` / ${t("subscription:MONTH")}`}
            </Text>
          </Box>
        </Box>
      </Stack>
      <Divider flexItem sx={{ border: '1px solid black' }} />
      <List className="subscriptionCarouselDetails">
        <ListItem>
          <ListItemText>
            {getCarouselSubscriptionPaymentDescription(data.period, formatPrice(data.price.amount, data.price.currency))}
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ textDecorationLine: data.period === 1 ? 'line-through' : undefined }}>
            {t('subscriptioncarousel:CARDSBLOCK_GUARANTEE')}
          </ListItemText>
        </ListItem>
      </List>
    </CarouselCard>
  );
};

export default SubscriptionCarouselCard;
